import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Description } from '@mui/icons-material';
import { deepPurple } from '@mui/material/colors';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { ActionsMenu } from 'components/shared/Menu/ActionsMenu';

import { FromToInfo } from './common/FromToInfo';
import { ActivityCardProps } from '../../types';
import { DealNoteActivity } from '../../api/types';
import { CardContainer } from './common/CardContainer';
import { ActionDirection } from './common/ActionDirection';

export const NoteCard = ({ entity, onUpdate, onDelete }: ActivityCardProps<DealNoteActivity>) => {
  const classes = useStyles();

  const { content, directionType, topic, createdDateTime, participants } = entity;

  return (
    <CardContainer>
      <Box className={classes.note}>
        <Box className="noteIcon">
          <Description sx={{ color: 'white', zIndex: 2 }} />
          <ActionDirection isInternal={directionType === 'INTERNAL'} />
        </Box>

        <Stack gap="0.25rem">
          <Typography variant="h6" component="span">
            {topic}
          </Typography>

          <Stack direction="row" gap="0.5rem" alignItems="center">
            <FromToInfo actionName="Note" participants={participants} actionDateTime={createdDateTime} />
          </Stack>
        </Stack>

        <ActionsMenu
          config={[
            { action: onUpdate, label: 'Edit' },
            { action: onDelete, label: 'Delete' },
          ]}
        />
      </Box>

      <Divider />

      <Typography>{content}</Typography>

      <Divider />
    </CardContainer>
  );
};

const useStyles = makeStyles({
  note: {
    gap: '1rem',
    width: '100%',
    display: 'grid',
    borderRadius: '0.5rem',
    alignItems: 'flex-start',
    gridTemplateColumns: 'auto 1fr auto',

    '& .noteIcon': {
      display: 'flex',
      padding: '0.6rem',
      alignItems: 'center',
      borderRadius: '100%',
      position: 'relative',
      justifyContent: 'center',
      backgroundColor: deepPurple[500],
    },
  },
});
